import { SignIn } from '@clerk/clerk-react'
import { MatrixRain } from '@/components/matrix-rain'
import { CLERK_APPEARANCE } from '@/components/layout/user-menu'

/**
 * Login page — branded entry that matches the marketing-site vibe:
 *   - obsidian backdrop with the signature radial cobalt glow
 *   - subtle grid overlay for technical-authority texture
 *   - split-color wordmark + mono tagline left of the Clerk widget
 *   - Clerk primitives themed with cobalt accents via appearance prop
 */
export default function LoginPage() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-background">
      {/* Depth layers — matrix rain sits behind grid + glow overlays */}
      <MatrixRain />
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-grid-subtle opacity-30" />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-[-10%] h-[520px] w-[720px] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(28,63,255,0.22)_0%,transparent_60%)] blur-3xl"
      />

      <div className="relative flex min-h-screen items-center justify-center px-4 py-12">
        <div className="flex w-full max-w-4xl flex-col items-center gap-10 md:flex-row md:items-center md:justify-center md:gap-16">
          {/* Brand block */}
          <div className="flex max-w-sm flex-col items-center gap-5 text-center md:items-start md:text-left">
            <img
              src="/dealcloser-logo.png"
              alt="DealCloser Autopilot"
              className="h-32 w-32 rounded-2xl shadow-[0_8px_40px_rgba(28,63,255,0.18)] ring-1 ring-white/5 select-none md:h-36 md:w-36"
              draggable={false}
            />
            <h1 className="text-3xl font-bold tracking-tight text-[var(--color-silver-bright)] md:text-4xl">
              <span className="text-gradient-cobalt">Your pipeline</span>, on autopilot.
            </h1>
            <p className="text-sm leading-relaxed text-[var(--color-silver)]">
              AI agents that find your ideal prospects, write personalized messages, handle the
              conversation, and book the call. You just show up.
            </p>
          </div>

          {/* Clerk widget */}
          <div className="w-full max-w-sm">
            <SignIn
              signUpUrl="/signup"
              fallbackRedirectUrl="/dashboard"
              appearance={CLERK_APPEARANCE}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
